import { useEffect } from "react"

import useFetch from "shared/model/useFetch"

const useGetMyExamList = () => {
    const [fetchResult, fetchRequest] = useFetch()

    useEffect(() => {
        fetchRequest("GET", `/tryout/payment/list/my`)
    }, [])

    return [fetchResult]
}

export default useGetMyExamList